"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Settings/Org/TabsHeader.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);







// A click doesn't focus the tab: once focused, any later key press (Escape,
// Shift, Cmd) makes the browser treat that focus as keyboard focus and draw
// the ring. Tab and Enter or Space still reach and choose it.
const keepFocus = (event) => event.preventDefault()

const TabItem = ({ isActive, label, onClick }) => {
  const onKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onClick()
    }
  }

  return (
    _react2.default.createElement('div', {
      role: "tab",
      tabIndex: 0,
      'aria-selected': isActive,
      onClick: onClick,
      onMouseDown: keepFocus,
      onKeyDown: onKeyDown,
      className: _classBuilder2.default.call(void 0, 
        "settings--org--tab-item",
        isActive && "settings--org--tab-item--active",
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}

      ,  label 
    )
  )
}












// The tab row of a settings page (an org or the account).
const TabsHeader = ({ tabs, activeTab, onSelect }) => (
  _react2.default.createElement('div', { className: "settings--org--tabs", role: "tablist", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}
    ,  tabs.map(t => (
      _react2.default.createElement(TabItem, {
        key: t.name,
        isActive: activeTab === t.name,
        label: t.label,
        onClick: () => onSelect(t.name), __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
      )
    ))
  )
)

exports. default = TabsHeader
